import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header, Icon, Message, Table } from 'semantic-ui-react';
import './retryAuditV1021.css';
import {
  latestRetryAttemptV111,
  numberRetryAttemptsV111,
  retryAttemptResultV111,
  retryRequestStateV111,
} from './retryPresentationV111';

export const effectiveSourceFallbackV1114 = (policy) =>
  Boolean(
    policy?.retry_enabled &&
      policy.source_fallback_enabled &&
      policy.mode !== 'physical' &&
      (policy.legacy_retry_limit == null
        ? policy.fallback_retries > 0
        : policy.legacy_retry_limit > 0)
  );

const words = {
  source_rule_v1114: ['Source 错误规则', 'Source error rule'],
  skip_same_source: ['跳过同源，尝试切换 Source', 'Skip same source; try another Source'],
  keep_same_source: ['例外命中，按原策略重试', 'Exception matched; use normal retry policy'],
  latest_attempt: ['最新尝试', 'Latest attempt'],
  attempt_success: ['成功', 'Succeeded'],
  attempt_failure: ['失败', 'Failed'],
  attempt_number: ['第 {{number}} 次', 'Attempt {{number}}'],
  dispatched_number: [
    '已发出第 {{number}} 次',
    'Dispatched attempt {{number}}',
  ],
  number_unknown: ['次数未记录', 'Number not recorded'],
  final_succeeded: ['最终结果：成功', 'Final result: Succeeded'],
  final_failed: ['最终结果：失败', 'Final result: Failed'],
  final_pending: ['整条请求：尚未结束', 'Overall request: Pending'],
  final_canceled: ['整条请求：已取消', 'Overall request: Canceled'],
  final_not_dispatched: ['最终结果：失败', 'Final result: Failed'],
  final_unknown: ['整条请求：结果未知', 'Overall request: Result unknown'],
  attempt_unknown: ['尝试类别未记录', 'Attempt classification not recorded'],
  channel_retry: ['同渠道重试', 'Same-channel retry'],
  chain: ['尝试过程', 'Attempt history'],
  summary_incomplete: ['尝试序列不完整', 'Attempt sequence is incomplete'],
  title: ['请求尝试记录', 'Request attempts'],
  strategy: ['请求时策略', 'Request-time strategy'],
  effective_strategy: ['实际策略', 'Effective strategy'],
  policy_mode: ['重试模式', 'Retry mode'],
  configured_budget: ['有效重试预算', 'Effective retry budget'],
  fallback_enabled_v1114: [
    '允许后备 Source 尝试',
    'Fallback Source attempts allowed',
  ],
  fallback_disabled_v1114: [
    '后备 Source 尝试未启用',
    'Fallback Source attempts disabled',
  ],
  preference: ['策略仅排序', 'Ranking preference'],
  manual_scope: ['手动 Source 范围', 'Manual Source scope'],
  ranked_unvisited: [
    '按策略尝试剩余 Source',
    'Remaining Sources in strategy order',
  ],
  higher_multiplier_unvisited: [
    '逐级提高倍率，每个后备 Source 仅尝试一次',
    'Strictly increasing multipliers; each fallback Source once',
  ],
  same_channel: ['仅同渠道重试', 'Same-channel retries only'],
  remaining_source_unavailable: [
    '没有剩余合格 Source',
    'No remaining eligible Source',
  ],
  higher_source_unavailable: [
    '没有更高倍率的合格 Source',
    'No eligible Source with a higher multiplier',
  ],
  inherit: ['继承', 'Inherited'],
  cheap: ['最低价格', 'Lowest price'],
  quality: ['全参、无压缩', 'Full parameters, uncompressed'],
  official: ['官方优先', 'Official preferred'],
  stable: ['稳定优先', 'Stable preferred'],
  speed: ['最快响应', 'Fastest response'],
  success: ['最高成功率', 'Highest success rate'],
  manual: ['指定 Source', 'Specified Sources'],
  categorized: ['分类重试', 'Categorized retries'],
  physical: [
    '同渠道重试（无 Source 定价）',
    'Same-channel retries (no Source pricing)',
  ],
  legacy: ['旧版总次数', 'Legacy total limit'],
  selection: ['选路阶段', 'Route selection'],
  routing_rejected: [
    '选路未通过，未发送上游',
    'Routing rejected before dispatch',
  ],
  quality_capability_not_configured: [
    '未配置全参、无压缩能力',
    'Full-parameter/uncompressed capabilities not configured',
  ],
  quality_capability_required: [
    '渠道未满足全参、无压缩要求',
    'Channel does not meet full-parameter/uncompressed requirements',
  ],
  capability_not_configured: [
    '渠道能力未配置',
    'Channel capabilities not configured',
  ],
  capability_protocol_denied: [
    '渠道不支持请求协议',
    'Channel does not support request protocol',
  ],
  capability_resolution_denied: [
    '渠道不支持请求分辨率',
    'Channel does not support request resolution',
  ],
  maximum_multiplier_exceeded: [
    '超过 Key 倍率上限',
    'Key multiplier ceiling exceeded',
  ],
  organization_channel_denied: [
    '组织未授权该渠道',
    'Channel not authorized for organization',
  ],
  key_channel_denied: ['Key 未授权该渠道', 'Channel not authorized for Key'],
  health_policy_denied: ['未满足健康策略', 'Health policy not satisfied'],
  request_parameter_unsupported: [
    '请求参数不受支持',
    'Request parameter not supported',
  ],
  retry_disabled: ['Key 已关闭重试', 'Retries disabled on Key'],
  billing_failure: [
    '计费校验失败，停止重试',
    'Billing validation failed; retries stopped',
  ],
  accepted_output_no_replay: [
    '已有受理结果，禁止重复生成',
    'Output accepted; duplicate generation forbidden',
  ],
  image_output_replay_unsafe: [
    '图片结果已产生，但无法安全重发',
    'Image output exists but cannot safely be replayed',
  ],
  same_source_unavailable: [
    '同源无可用渠道或凭据',
    'No usable channel or credential for the same Source',
  ],
  legacy_retry_stopped: [
    '旧版重试已停止，具体原因未记录',
    'Legacy retries stopped; specific reason not recorded',
  ],
  same_source_retry_budget_exhausted: [
    '同源重试次数已用尽，无法再次兼容重发',
    'Same-source retry limit reached; compatibility resend unavailable',
  ],
  rejections: ['候选排除原因', 'Candidate exclusions'],
  organization_source_denied: [
    '组织未授权该 Source',
    'Source not authorized for organization',
  ],
  key_source_denied: ['Key 未授权该 Source', 'Source not authorized for Key'],
  source_directory_unavailable: [
    'Source 目录不可用',
    'Source directory unavailable',
  ],
  source_binding_unavailable: [
    'Source 绑定不可用',
    'Source binding unavailable',
  ],
  frozen_source_mismatch: [
    '不属于本次已锁定的 Source',
    'Outside the frozen Source',
  ],
  receipt_policy_unavailable: [
    '回执计价策略不可用',
    'Receipt pricing policy unavailable',
  ],
  source_keys_unavailable: [
    'Source 没有可用凭据',
    'No usable credentials for Source',
  ],
  retry_channel_setup_rejected: [
    '重试渠道初始化未通过',
    'Retry channel setup rejected',
  ],
  offer_policy_denied: [
    '套餐或倍率授权不符',
    'Offer or multiplier authorization mismatch',
  ],
  explicit_channel_pinned: ['请求固定了渠道', 'Request is pinned to a channel'],
  request_id: ['请求 ID', 'Request ID'],
  sequence: ['顺序 / 时间', 'Sequence / time'],
  stage: ['类别 / 阶段', 'Category / stage'],
  source: ['Source / 倍率', 'Source / multiplier'],
  trigger: ['触发原因', 'Trigger'],
  result: ['尝试结果', 'Attempt result'],
  stop: ['停止原因', 'Stop reason'],
  attempts: ['已发出', 'Dispatched'],
  same_source: ['同源重试', 'Same-source retries'],
  fallback: ['Fallback 重试', 'Fallback retries'],
  request: ['首次请求', 'Initial request'],
  same_source_retry: ['同源重试', 'Same-source retry'],
  fallback_retry: ['Fallback 重试', 'Fallback retry'],
  language: ['语言模型', 'Language'],
  image: ['图像模型', 'Image'],
  video: ['视频模型', 'Video'],
  other: ['其他模型', 'Other'],
  request_success: ['请求成功', 'Request succeeded'],
  request_failure: ['请求失败', 'Request failed'],
  same_source_retry_success: ['同源重试成功', 'Same-source retry succeeded'],
  same_source_retry_failure: ['同源重试失败', 'Same-source retry failed'],
  fallback_retry_success: ['Fallback 重试成功', 'Fallback retry succeeded'],
  fallback_retry_failure: ['Fallback 重试失败', 'Fallback retry failed'],
  pending: ['尚未结束', 'Pending'],
  canceled: ['已取消', 'Canceled'],
  not_dispatched: ['未发往上游', 'Not dispatched'],
  unknown: ['未记录 / 未知', 'Not recorded / unknown'],
  not_recorded: ['未记录重试分类', 'Retry classification not recorded'],
  unavailable: ['尝试记录暂不可用', 'Attempt records unavailable'],
  truncated: ['尝试序列不完整', 'Attempt sequence is incomplete'],
  partial: [
    '部分尝试未记录分类',
    'Some attempts have no recorded classification',
  ],
  retry_budget_exhausted: ['重试次数已用尽', 'Retry limit reached'],
  budget_exhausted: ['重试次数已用尽', 'Retry limit reached'],
  request_succeeded: ['请求已成功', 'Request succeeded'],
  no_higher_multiplier_source: [
    '没有符合条件的更高倍率 Source',
    'No eligible higher-multiplier Source',
  ],
  higher_multiplier_source_unavailable: [
    '没有符合条件的更高倍率 Source',
    'No eligible higher-multiplier Source',
  ],
  retry_authorization_failed: [
    '重试路由权限校验未通过',
    'Retry routing authorization failed',
  ],
  retry_policy_unavailable: ['重试策略暂不可用', 'Retry policy unavailable'],
  request_body_unavailable: [
    '无法重新读取请求内容',
    'Request body cannot be replayed',
  ],
  client_request_canceled: ['客户端取消请求', 'Client canceled the request'],
  client_canceled: ['客户端取消请求', 'Client canceled the request'],
  state_affinity: ['请求需保持会话关联', 'Request requires session affinity'],
  non_retryable_error: ['此错误不允许重试', 'This error cannot be retried'],
  no_eligible_source: ['没有符合条件的 Source', 'No eligible Source'],
  no_higher_source: [
    '没有符合条件的更高倍率 Source',
    'No eligible higher-multiplier Source',
  ],
  retry_replay_forbidden: ['禁止重复发送此请求', 'Replay is not permitted'],
  replay_forbidden: ['禁止重复发送此请求', 'Replay is not permitted'],
  response_committed: ['响应已开始输出', 'Response output has started'],
  responses_state_affinity: [
    '请求绑定会话或后台状态，不能安全重发',
    'Session-bound or background request cannot safely be replayed',
  ],
  responses_provider_tool: [
    '包含上游执行工具，无法排除重复执行风险',
    'Provider-executed tools may have run; replay is unsafe',
  ],
  responses_request_unproven: [
    '请求结构或工具类型无法确认安全重发',
    'Request or tool structure does not prove replay safety',
  ],
  responses_inspection_limit: [
    '输出前检查超时或超限，未能证明可以安全重发',
    'Pre-output inspection timed out or exceeded its limit; replay is unproven',
  ],
  responses_replay_unproven: [
    '上游事件或结束状态无法证明安全重发',
    'Upstream events or stream ending do not prove replay safety',
  ],
  submission_unknown: [
    '生成提交结果未知',
    'Generation submission is uncertain',
  ],
  video_rate_limited_unaccepted: [
    '上游限流，确认未创建视频任务',
    'Rate limited before a video task was created',
  ],
  video_submission_accepted: [
    '视频任务已受理，等待结果',
    'Video accepted; awaiting result',
  ],
  submission_outcome_unknown_no_retry: [
    '提交结果未知，已停止重发',
    'Submission uncertain; replay stopped',
  ],
  submission_response_unconfirmed: [
    '无法确认提交结果',
    'Submission response cannot be confirmed',
  ],
  invalid_video_provider_response: [
    '无法确认视频任务响应',
    'Video task response cannot be confirmed',
  ],
  video_receipt_retry_unsafe: [
    '回执计价任务不允许重发',
    'Receipt-priced work cannot be replayed',
  ],
  video_receipt_identity_persistence_failed: [
    '任务回执保存失败，已停止重发',
    'Receipt identity could not be saved; replay stopped',
  ],
  video_rejection_persistence_failed: [
    '未受理记录保存失败，已停止重发',
    'Rejection record could not be saved; replay stopped',
  ],
  video_retry_audit_unavailable: [
    '重试记录暂不可保存',
    'Retry audit cannot be saved',
  ],
  video_dispatch_not_authorized: [
    '视频发送权限校验未通过',
    'Video dispatch authorization failed',
  ],
  video_legacy_no_retry: [
    '旧版视频模式不自动重发',
    'Legacy video mode does not retry',
  ],
  video_retry_source_incompatible: [
    '下一个 Source 不兼容此视频请求',
    'Next Source is incompatible with this video request',
  ],
  video_retry_reservation_denied: [
    '重试额度预留未通过',
    'Retry reservation was denied',
  ],
  video_retry_after_unconfirmed: [
    '无法确认上游要求的等待时间',
    'Upstream retry delay cannot be confirmed',
  ],
  video_retry_after_exceeds_limit: [
    '上游要求的等待时间超过自动重试上限',
    'Upstream retry delay exceeds the automatic retry limit',
  ],
  upstream_timeout: ['上游超时', 'Upstream timeout'],
  upstream_first_byte_timeout: [
    '等待上游响应超时',
    'Upstream response timeout',
  ],
};

const kinds = new Set(['request', 'same_source_retry', 'fallback_retry']);
const categories = new Set(['language', 'image', 'video', 'other']);
const outcomes = new Set([
  ...[...kinds].flatMap((kind) => [`${kind}_success`, `${kind}_failure`]),
  'pending',
  'canceled',
  'not_dispatched',
  'unknown',
]);
const code = (value) =>
  typeof value === 'string' &&
  /^[a-zA-Z0-9_.:-]{1,128}$/.test(value) &&
  !/sk-|dckr_pat_/i.test(value)
    ? value
    : '';
const integer = (value) =>
  Number.isSafeInteger(value) && value >= 0 ? value : 0;
const text = (value, length = 128) =>
  typeof value === 'string'
    ? value
        .replace(
          /https?:\/\/\S+|bearer\s+\S+|(?:api[_-]?key|access[_-]?token|secret|credential|password|authorization|cookie)\s*[:=]\s*\S+|sk-[a-z0-9_-]{8,}|dckr_pat_[a-z0-9_-]+/gi,
          '[redacted]'
        )
        .replace(/[\u0000-\u001f\u007f]/g, '')
        .slice(0, length)
    : '';
const multiplier = (value) =>
  typeof value === 'string' && /^(0|[1-9]\d{0,11})(\.\d{1,18})?$/.test(value)
    ? value
    : '';

const policySafeV1022 = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const strategies = new Set([
    'inherit',
    'cheap',
    'quality',
    'official',
    'stable',
    'speed',
    'success',
    'manual',
  ]);
  return {
    key_strategy: strategies.has(value.key_strategy) ? value.key_strategy : '',
    effective_strategy: strategies.has(value.effective_strategy)
      ? value.effective_strategy
      : '',
    category: categories.has(value.category) ? value.category : '',
    mode: ['selection', 'categorized', 'legacy', 'physical'].includes(
      value.mode
    )
      ? value.mode
      : '',
    retry_enabled: value.retry_enabled === true,
    source_fallback_enabled: value.source_fallback_enabled === true,
    same_source_retries: Math.min(integer(value.same_source_retries), 5),
    fallback_retries: Math.min(integer(value.fallback_retries), 5),
    legacy_retry_limit: Number.isSafeInteger(value.legacy_retry_limit)
      ? integer(value.legacy_retry_limit)
      : null,
    maximum_multiplier: multiplier(value.maximum_multiplier),
    strategy_semantics: ['preference', 'manual_scope'].includes(
      value.strategy_semantics
    )
      ? value.strategy_semantics
      : '',
    fallback_order: [
      'higher_multiplier_unvisited',
      'ranked_unvisited',
      'legacy',
      'same_channel',
    ].includes(value.fallback_order)
      ? value.fallback_order
      : '',
  };
};

// Whitelist nested fields as well as the top-level log field. Never copy raw
// route diagnostics into the customer timeline, including when debug is on.
export const retrySummarySafeV1021 = (value, requestID) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  if (requestID && value.request_id !== requestID) return null;
  const status = ['recorded', 'not_recorded', 'unavailable'].includes(
    value.status
  )
    ? value.status
    : 'not_recorded';
  return {
    status,
    request_state_v111: [
      'succeeded',
      'failed',
      'pending',
      'canceled',
      'not_dispatched',
      'unknown',
    ].includes(value.request_state_v111)
      ? value.request_state_v111
      : '',
    latest_attempt_v111:
      value.latest_attempt_v111 &&
      typeof value.latest_attempt_v111 === 'object' &&
      !Array.isArray(value.latest_attempt_v111)
        ? safeAttemptsV1022(
            [value.latest_attempt_v111],
            1,
            initialNotDispatchedV118(
              value.attempt_sequence_v1022 || value.attempts
            )
          )[0]
        : null,
    request_id: text(value.request_id, 191),
    outcome:
      status === 'recorded' && outcomes.has(value.outcome)
        ? value.outcome
        : 'unknown',
    category: categories.has(value.category) ? value.category : '',
    attempt_count:
      Number.isSafeInteger(value.attempt_count) && value.attempt_count >= 0
        ? value.attempt_count
        : null,
    same_source_retries:
      Number.isSafeInteger(value.same_source_retries) &&
      value.same_source_retries >= 0
        ? value.same_source_retries
        : null,
    fallback_retries:
      Number.isSafeInteger(value.fallback_retries) &&
      value.fallback_retries >= 0
        ? value.fallback_retries
        : null,
    unknown_attempt_count: integer(value.unknown_attempt_count),
    stop_code: code(value.stop_code),
    source_retry_decision_v1114: safeSourceDecisionV1114(value.source_retry_decision_v1114),
    truncated: value.truncated === true,
    policy_v1022: policySafeV1022(value.policy_v1022),
    attempt_sequence_v1022: safeAttemptsV1022(
      value.attempt_sequence_v1022 || value.attempts,
      12
    ),
    rejections_v1022: (Array.isArray(value.rejections_v1022)
      ? value.rejections_v1022
      : []
    )
      .slice(0, 64)
      .filter((item) => item && code(item.code) && integer(item.count) > 0)
      .map((item) => ({ code: code(item.code), count: integer(item.count) })),
  };
};

const safeSourceDecisionV1114 = (v) => v && code(v.rule_id) && ['skip_same_source', 'keep_same_source'].includes(v.action) ? { rule_id: code(v.rule_id), action: v.action, after_attempt: integer(v.after_attempt) } : null;

const initialNotDispatchedV118 = (attempts) =>
  Array.isArray(attempts) &&
  attempts[0]?.kind === 'request' &&
  attempts[0]?.ordinal === 1 &&
  attempts[0]?.dispatched === false;

const safeAttemptsV1022 = (
  value,
  limit = 500,
  initialUnsent = initialNotDispatchedV118(value)
) =>
  (Array.isArray(value) ? value.slice(0, limit) : [])
    .filter(
      (attempt) =>
        attempt && typeof attempt === 'object' && !Array.isArray(attempt)
    )
    .map((attempt, index) => {
      const typed =
        kinds.has(attempt.kind) &&
        categories.has(attempt.category) &&
        integer(attempt.ordinal) > 0;
      return {
        sequence: index + 1,
        retry_number_v111:
          typed &&
          Number.isSafeInteger(attempt.retry_number_v111) &&
          attempt.retry_number_v111 > 0 &&
          (attempt.retry_number_v111 < attempt.ordinal ||
            (initialUnsent && attempt.retry_number_v111 === attempt.ordinal))
            ? attempt.retry_number_v111
            : null,
        ordinal: typed ? integer(attempt.ordinal) : 0,
        category: typed ? attempt.category : '',
        kind: typed ? attempt.kind : '',
        identity_basis: ['source', 'channel'].includes(attempt.identity_basis)
          ? attempt.identity_basis
          : '',
        source_name: typed ? text(attempt.source_name) : '',
        multiplier: typed ? multiplier(attempt.multiplier) : '',
        trigger_code: typed ? code(attempt.trigger_code) : '',
        source_rule_id_v1114: typed ? code(attempt.source_rule_id_v1114) : '',
        source_rule_action_v1114: ['skip_same_source', 'keep_same_source'].includes(attempt.source_rule_action_v1114) ? attempt.source_rule_action_v1114 : '',
        error_code: typed ? code(attempt.error_code) : '',
        outcome:
          typed &&
          outcomes.has(attempt.outcome) &&
          (!attempt.outcome.includes('_') ||
            attempt.outcome === 'not_dispatched' ||
            attempt.outcome.startsWith(`${attempt.kind}_`))
            ? attempt.outcome
            : 'unknown',
        dispatched: attempt.dispatched === true,
        started_at_ms: integer(attempt.started_at_ms),
        finished_at_ms: integer(attempt.finished_at_ms),
      };
    });

export const retryAuditSafeV1021 = (value, requestID) => {
  const summary = retrySummarySafeV1021(value, requestID);
  if (!summary) return null;
  return {
    ...summary,
    attempts: safeAttemptsV1022(
      value.attempts || summary.attempt_sequence_v1022
    ),
  };
};

const useRetryTextV1021 = () => {
  const { t, i18n } = useTranslation();
  const chinese = String(
    i18n?.resolvedLanguage || i18n?.language || 'en'
  ).startsWith('zh');
  return (key, values = {}) =>
    words[key]
      ? t(`retry_audit_v1021.${key}`, {
          defaultValue: words[key][chinese ? 0 : 1],
          ...values,
        })
      : key || '-';
};

export const RetryOutcomeV1021 = ({ outcome }) => {
  const label = useRetryTextV1021();
  const valid = outcomes.has(outcome) ? outcome : 'unknown';
  const state = valid.endsWith('_success')
    ? 'success'
    : valid.endsWith('_failure')
    ? 'failure'
    : 'neutral';
  return (
    <span className={`retry-outcome-v1021 ${state}`}>
      <Icon
        aria-hidden='true'
        name={
          state === 'success'
            ? 'check circle outline'
            : state === 'failure'
            ? 'times circle outline'
            : valid === 'pending'
            ? 'clock outline'
            : 'minus circle'
        }
      />
      {label(valid)}
    </span>
  );
};

export const RetryRouteMetadataV1021 = ({ value }) => {
  const label = useRetryTextV1021();
  const meta = retryAuditSafeV1021({
    status: 'recorded',
    attempts: [{ ...value, outcome: 'unknown' }],
  }).attempts[0];
  if (!meta?.kind) return <span>{label('unknown')}</span>;
  return (
    <div>
      <div>
        #{meta.ordinal} {label(meta.category)} / {attemptTitleV111(meta, label)}
      </div>
      <div>
        {meta.source_name || label('unknown')}{' '}
        {meta.multiplier ? `${meta.multiplier}x` : ''}
      </div>
      {meta.trigger_code && (
        <div>
          {label('trigger')}: <code>{meta.trigger_code}</code>
        </div>
      )}
    </div>
  );
};

const attemptTitleV111 = (attempt, label) => {
  if (!attempt?.kind) return label('attempt_unknown');
  if (attempt.kind === 'request') return label('request');
  const kind =
    attempt.identity_basis === 'channel' && attempt.kind === 'same_source_retry'
      ? 'channel_retry'
      : attempt.kind;
  // Same-source display counts the initial send; stored retry budgets do not.
  const number = attempt.retry_number_v111
    ? attempt.retry_number_v111 + (attempt.kind === 'same_source_retry' ? 1 : 0)
    : null;
  return `${label(kind)} · ${
    number
      ? label('attempt_number', {
          number,
        }).replaceAll('{{number}}', String(number))
      : label('number_unknown')
  }`;
};

export const RetryAttemptStateV111 = ({ attempt }) => {
  const label = useRetryTextV1021();
  const result = retryAttemptResultV111(attempt);
  const state =
    result === 'attempt_success'
      ? 'success'
      : result === 'attempt_failure'
      ? 'failure'
      : 'neutral';
  return (
    <span className={`retry-attempt-state-v111 ${state}`}>
      <strong>{attemptTitleV111(attempt, label)}</strong>
      {' · '}
      <span>{label(result)}</span>
    </span>
  );
};

const terminalRequestV111 = (state) =>
  ['succeeded', 'failed', 'not_dispatched'].includes(state);

const RetryFinalResultV111 = ({ state }) => {
  const label = useRetryTextV1021();
  if (!terminalRequestV111(state)) return null;
  return (
    <span
      className={`retry-final-v111 ${state}`}
      data-testid='retry-final-v111'
    >
      <Icon
        aria-hidden='true'
        name={
          state === 'succeeded'
            ? 'check circle outline'
            : 'times circle outline'
        }
      />
      {label(`final_${state}`)}
    </span>
  );
};

export const RetrySummaryV1021 = ({
  value,
  requestID,
  showFinalResult = true,
}) => {
  const label = useRetryTextV1021();
  const summary = retrySummarySafeV1021(value, requestID);
  if (!summary) return null;
  const state = retryRequestStateV111(summary);
  const latest = latestRetryAttemptV111(summary);
  const attempts = numberRetryAttemptsV111(
    summary.attempt_sequence_v1022,
    summary.truncated
  );
  return (
    <div className='retry-summary-v1021' data-testid='retry-summary-v1021'>
      <div className='retry-latest-v111'>
        <span>{label('latest_attempt')}: </span>
        {latest ? (
          <RetryAttemptStateV111 attempt={latest} />
        ) : (
          <span>{label('attempt_unknown')}</span>
        )}
        {showFinalResult && <RetryFinalResultV111 state={state} />}
      </div>
      {!terminalRequestV111(state) && (
        <div className={`retry-request-status-v111 ${state}`}>
          {label(`final_${state}`)}
        </div>
      )}
      {summary.status !== 'recorded' && <div>{label(summary.status)}</div>}
      {summary.policy_v1022 && (
        <div className='retry-policy-v1022'>
          {label('strategy')}:{' '}
          {label(summary.policy_v1022.key_strategy || 'unknown')}
          {' / '}
          {label(summary.policy_v1022.effective_strategy || 'unknown')}
        </div>
      )}
      {summary.status === 'recorded' && (
        <div className='retry-counts-v1021'>
          <span>
            {summary.attempt_count > 0
              ? label('dispatched_number', {
                  number: summary.attempt_count,
                }).replaceAll('{{number}}', String(summary.attempt_count))
              : `${label('attempts')} ${
                  summary.attempt_count ?? label('unknown')
                }`}
          </span>
          {latest?.dispatched &&
            ['same_source_retry', 'fallback_retry'].includes(latest.kind) && (
              <span>{attemptTitleV111(latest, label)}</span>
            )}
        </div>
      )}
      {summary.status === 'recorded' &&
        summary.stop_code &&
        summary.stop_code !== 'request_succeeded' &&
        state !== 'succeeded' && (
          <div
            className='retry-stop-v1021'
            data-testid='retry-stop-summary-v113'
          >
            {label('stop')}: {label(summary.stop_code)}
          </div>
        )}
      {attempts.length > 0 && (
        <details className='retry-chain-v111'>
          <summary>{label('chain')}</summary>
          <ol>
            {attempts.map((attempt) => (
              <li key={attempt.sequence}>
                <RetryAttemptStateV111 attempt={attempt} />
              </li>
            ))}
          </ol>
        </details>
      )}
      {summary.truncated && <div>{label('summary_incomplete')}</div>}
    </div>
  );
};

const timestamp = (value) =>
  value > 0 && value < 8640000000000000
    ? new Date(value).toLocaleString()
    : '-';

export const RetryAuditTimelineV1021 = ({ value, requestID }) => {
  const label = useRetryTextV1021();
  const audit = retryAuditSafeV1021(value, requestID);
  if (!audit) return null;
  const last = audit.attempts[audit.attempts.length - 1];
  const finalAttemptIncluded =
    last &&
    (!audit.truncated ||
      (audit.latest_attempt_v111?.ordinal > 0 &&
        audit.latest_attempt_v111.ordinal === last.ordinal));
  return (
    <section className='retry-audit-v1021' aria-label={label('title')}>
      <Header as='h4'>{label('title')}</Header>
      <div className='retry-request-v1021'>
        <span>
          {label('request_id')} <code>{audit.request_id}</code>
        </span>
        <RetrySummaryV1021
          value={audit}
          requestID={requestID}
          showFinalResult={!finalAttemptIncluded}
        />
      </div>
      {audit.policy_v1022 && (
        <p className='retry-stop-v1021'>
          {label('policy_mode')}: {label(audit.policy_v1022.mode || 'unknown')}
          {' | '}
          {label(audit.policy_v1022.category || 'unknown')}
          {' | '}
          {label('configured_budget')}:{' '}
          {audit.policy_v1022.legacy_retry_limit == null
            ? `${audit.policy_v1022.same_source_retries} + ${audit.policy_v1022.fallback_retries}`
            : audit.policy_v1022.legacy_retry_limit}
          {!audit.policy_v1022.retry_enabled && ` | ${label('retry_disabled')}`}
          {' | '}
          {label(
            effectiveSourceFallbackV1114(audit.policy_v1022)
              ? 'fallback_enabled_v1114'
              : 'fallback_disabled_v1114'
          )}
          {audit.policy_v1022.strategy_semantics &&
            ` | ${label(audit.policy_v1022.strategy_semantics)}`}
          {audit.policy_v1022.fallback_order &&
            ` | ${label(audit.policy_v1022.fallback_order)}`}
        </p>
      )}
      {audit.rejections_v1022.length > 0 && (
        <div className='retry-stop-v1021'>
          {label('rejections')}:
          <ul>
            {audit.rejections_v1022.map((item) => (
              <li key={item.code}>
                {label(item.code)} ({item.count}) <code>{item.code}</code>
              </li>
            ))}
          </ul>
        </div>
      )}
      {audit.source_retry_decision_v1114 && <p className='retry-stop-v1021'>
        {label('source_rule_v1114')}: <code>{audit.source_retry_decision_v1114.rule_id}</code> · {label(audit.source_retry_decision_v1114.action)}
      </p>}
      {audit.stop_code && (
        <p className='retry-stop-v1021'>
          {label('stop')}: {label(audit.stop_code)}{' '}
          <code>{words[audit.stop_code] ? audit.stop_code : ''}</code>
        </p>
      )}
      {audit.truncated && (
        <Message warning size='small' content={label('truncated')} />
      )}
      {audit.status === 'recorded' && audit.unknown_attempt_count > 0 && (
        <Message size='small' content={label('partial')} />
      )}
      {audit.attempts.length > 0 && (
        <div
          className='retry-audit-scroll-v1021'
          role='region'
          aria-label={label('title')}
          tabIndex={0}
        >
          <Table compact celled unstackable className='retry-audit-table-v1021'>
            <Table.Header>
              <Table.Row>
                {['sequence', 'stage', 'source', 'trigger', 'result'].map(
                  (key) => (
                    <Table.HeaderCell key={key}>{label(key)}</Table.HeaderCell>
                  )
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {numberRetryAttemptsV111(audit.attempts, audit.truncated).map(
                (attempt, index) => (
                  <Table.Row key={attempt.sequence}>
                    <Table.Cell>
                      <strong>#{attempt.sequence}</strong>
                      <div>{timestamp(attempt.started_at_ms)}</div>
                    </Table.Cell>
                    <Table.Cell>
                      <div>{label(attempt.category || 'unknown')}</div>
                      <strong>{attemptTitleV111(attempt, label)}</strong>
                    </Table.Cell>
                    <Table.Cell>
                      <div>{attempt.source_name || label('unknown')}</div>
                      {attempt.multiplier ? (
                        <code>{attempt.multiplier}x</code>
                      ) : (
                        '-'
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {label(attempt.trigger_code)}
                      {attempt.source_rule_id_v1114 && <div>{label(attempt.source_rule_action_v1114)} · <code>{attempt.source_rule_id_v1114}</code></div>}
                      {attempt.trigger_code && words[attempt.trigger_code] && (
                        <div>
                          <code>{attempt.trigger_code}</code>
                        </div>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      <RetryOutcomeV1021 outcome={attempt.outcome} />
                      {index === audit.attempts.length - 1 &&
                        finalAttemptIncluded && (
                          <RetryFinalResultV111
                            state={retryRequestStateV111(audit)}
                          />
                        )}
                      {attempt.error_code && (
                        <div>
                          <code>{attempt.error_code}</code>
                        </div>
                      )}
                    </Table.Cell>
                  </Table.Row>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      )}
    </section>
  );
};

// Copy uses the same safe projection as the table. Different request IDs are
// separate inbound requests; adjacency never establishes retry causality.
export const retryTextV1022 = (value, requestID) => {
  const audit = retryAuditSafeV1021(value, requestID);
  if (!audit) return '[Retry] Not recorded / 未记录\n';
  const label = (key) =>
    words[key] ? `${words[key][0]} / ${words[key][1]}` : key || 'unknown';
  const p = audit.policy_v1022;
  const numberLabel = (key, values) =>
    label(key).replaceAll('{{number}}', String(values?.number || ''));
  const latest = latestRetryAttemptV111(audit);
  const state = retryRequestStateV111(audit);
  const lines = [
    `[Request Chain] ${audit.request_id} | ${label(
      audit.status === 'recorded' ? audit.outcome : audit.status
    )}`,
  ];
  if (!terminalRequestV111(state) || !latest)
    lines.push(`[Overall Request] ${label(`final_${state}`)}`);
  if (latest)
    lines.push(
      `[Latest Attempt] ${attemptTitleV111(latest, numberLabel)} | ${label(
        retryAttemptResultV111(latest)
      )}${terminalRequestV111(state) ? ` | ${label(`final_${state}`)}` : ''}`
    );
  if (p) {
    lines.push(
      `[Policy] Key: ${label(p.key_strategy)} | Effective: ${label(
        p.effective_strategy
      )} | Category: ${p.category} | Mode: ${p.mode} | Semantics: ${
        p.strategy_semantics ? label(p.strategy_semantics) : 'not_recorded'
      } | Fallback order: ${
        p.fallback_order ? label(p.fallback_order) : 'not_recorded'
      }`
    );
    lines.push(
      `[Retry Budget] Enabled: ${p.retry_enabled} | Same: ${
        p.same_source_retries
      } | Fallback: ${p.fallback_retries} | Legacy: ${
        p.legacy_retry_limit ?? '-'
      } | Source fallback: ${
        p.source_fallback_enabled
      } | Effective Source fallback: ${effectiveSourceFallbackV1114(p)}`
    );
  }
  lines.push(
    `[Retry] Dispatched: ${audit.attempt_count ?? label('unknown')} | Same: ${
      audit.same_source_retries ?? label('unknown')
    } | Fallback: ${audit.fallback_retries ?? label('unknown')} | Stop: ${label(
      audit.stop_code
    )}`
  );
  for (const item of audit.rejections_v1022)
    lines.push(`[Routing Exclusion] ${label(item.code)} (${item.count})`);
  for (const a of numberRetryAttemptsV111(audit.attempts, audit.truncated))
    lines.push(
      `[Attempt #${a.ordinal || a.sequence}] ${attemptTitleV111(
        a,
        numberLabel
      )} | Basis: ${a.identity_basis || 'unknown'} | ${label(
        a.outcome
      )} | Source: ${a.source_name || '-'} | Multiplier: ${
        a.multiplier || '-'
      } | Trigger: ${a.trigger_code || '-'} | Source rule: ${a.source_rule_id_v1114 || '-'} (${a.source_rule_action_v1114 || '-'}) | Error: ${
        a.error_code || '-'
      } | Dispatched: ${a.dispatched}`
    );
  return lines.join('\n') + '\n';
};
